const CONTEXT_LABELS: Record<string, string> = {
  news: 'Notícias',
  members: 'Membros',
  history: 'História',
  events: 'Eventos',
};

export interface ImageItem {
  id: number;
  context: string;
  altText: string;
  url: string | null;
}

interface ImageCardProps {
  image: ImageItem;
  onDelete: (id: number) => void;
}

function ImageCard({ image, onDelete }: ImageCardProps) {
  return (
    <div className="group w-full">
      <div className="border-line bg-background aspect-square overflow-hidden rounded-lg border">
        {image.url ? (
          <button
            type="button"
            onClick={() => window.open(image.url!, '_blank')}
            aria-label={`Abrir imagem: ${image.altText}`}
            className="block h-full w-full cursor-pointer"
          >
            <img
              src={image.url}
              alt={image.altText}
              className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
            />
          </button>
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <span className="material-symbols-outlined text-on-surface-light/40">broken_image</span>
          </div>
        )}
      </div>
      <div className="mt-1.5 flex items-start justify-between gap-1">
        <div className="min-w-0">
          <p className="text-on-surface truncate text-xs">{image.altText}</p>
          <p className="text-on-surface-light text-xs">
            {CONTEXT_LABELS[image.context] ?? image.context}
          </p>
        </div>
        <button
          type="button"
          onClick={() => onDelete(image.id)}
          aria-label="Eliminar imagem"
          className="text-on-surface-light hover:bg-error/10 hover:text-error flex-shrink-0 rounded-md p-1 transition-colors"
        >
          <span className="material-symbols-outlined text-[16px]">delete</span>
        </button>
      </div>
    </div>
  );
}

interface ImagesGridProps {
  images: ImageItem[];
  onDelete: (id: number) => void;
}

export function ImagesGrid({ images, onDelete }: ImagesGridProps) {
  if (images.length === 0) {
    return (
      <div className="text-on-surface-light flex flex-col items-center gap-2 py-12 text-center text-sm">
        <span className="material-symbols-outlined text-on-surface-light/40 text-3xl">image</span>
        Nenhuma imagem encontrada.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
      {images.map((img) => (
        <ImageCard key={img.id} image={img} onDelete={onDelete} />
      ))}
    </div>
  );
}
